const generatetextValueForNotifications = (email, sms) => {
  if (email && sms) {
    return 'On: Email and SMS';
  }
  if (email && !sms) {
    return 'On: Email';
  }
  if (sms && !email) {
    return 'On: SMS';
  }

  return 'Off';
};

export const getNotificationsFieldsToEdit = ({
  unsubscribeFromNewDealsEmail,
  unsubscribeFromNewDealsSMS,
  unsubscribeFromEodEmail,
  unsubscribeFromEodSMS,
  unsubscribeFromOfferFollowUps,
  unsubscribeFromOfferFollowUpsSMS,
  globalNotificationsRecipients,
  webhooks,
}) => [
  {
    fieldName: 'newDeals',
    label: 'New deal',
    subTitle:
      'Get notified the moment a deal matching your exact criteria is sent to your dashboard.',
    textValue: generatetextValueForNotifications(
      !unsubscribeFromNewDealsEmail,
      !unsubscribeFromNewDealsSMS,
    ),
    emailValue: !unsubscribeFromNewDealsEmail,
    smsValue: !unsubscribeFromNewDealsSMS,
  },
  {
    fieldName: 'dealFollowUps',
    label: 'New deal follow-ups',
    subTitle: 'Receive a reminder for deals that require your attention.',
    textValue: generatetextValueForNotifications(
      !unsubscribeFromOfferFollowUps,
      !unsubscribeFromOfferFollowUpsSMS,
    ),
    emailValue: !unsubscribeFromOfferFollowUps,
    smsValue: !unsubscribeFromOfferFollowUpsSMS,
  },
  {
    fieldName: 'eodReport',
    label: 'EOD Report',
    subTitle:
      'Receive a daily summary of all deals that need your attention and action.',
    textValue: generatetextValueForNotifications(
      !unsubscribeFromEodEmail,
      !unsubscribeFromEodSMS,
    ),
    emailValue: !unsubscribeFromEodEmail,
    smsValue: !unsubscribeFromEodSMS,
  },
  {
    fieldName: 'globalNotificationRecipients',
    label: 'Global notification recipients',
    subTitle: `The email addresses you enter here will receive every single deal, in addition to the members of your company or the recipients specified in the buy box recipients feature.`,
    value: globalNotificationsRecipients,
  },
  {
    fieldName: 'crmApiIntegration',
    label: 'CRM API Integration',
    subTitle:
      'Connect Zorba deals directly to your CRM with webhooks and get notified when a seller lowers their asking price.',
    value: webhooks,
  },
];

export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return '';

  const digits = phoneNumber.replace(/\D/g, '');

  if (digits.length === 10) {
    return `${digits.slice(0, 3)} *** **${digits.slice(-2)}`;
  }

  return `+1 ${phoneNumber}`;
};
